import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import LoadingScreen from './LoadingScreen';
import AlertSnackbar from './AlertSnackbar';
import LuxAppBar from './LuxAppBar';

export default function Layout({ loading, snackbars, setSnackbars }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', bgcolor: '#f8f9fa' }}>
      <LuxAppBar />
      <Box sx={{ flexGrow: 1, overflow: 'hidden', mt: 7, p: 3 }}>
        <Outlet />
      </Box>
      <LoadingScreen loading={loading} />
      <AlertSnackbar snackbars={snackbars} setSnackbars={setSnackbars} />
    </Box>
  )
}